import {isEqual, isValid} from 'date-fns';
import {LOCAL_STORAGE_MY_NEWS_LAST_ADDED_DATE_KEY} from './constants';

export function getIsMyNewsUpdated(myNewsLastAddedDate?: Date) {
  const prevAddedDate = window.localStorage.getItem(
    LOCAL_STORAGE_MY_NEWS_LAST_ADDED_DATE_KEY
  );

  // 이전 기록이 없거나 인풋 Date가 존재하지 않거나 유효하지 않다면 레드 닷을 붙여주지 않습니다.
  if (!prevAddedDate || !myNewsLastAddedDate || !isValid(myNewsLastAddedDate)) {
    return false;
  } else {
    // 이전 기록과 현재 데이터가 같지 않다면, New 뱃지를 붙여줍니다.
    return !isEqual(new Date(prevAddedDate), myNewsLastAddedDate);
  }
}
